import type { APIGeolocationListItem } from '@yescapa-dev/ysc-api-js/modern'

export const getPlaceLinks = (links: APIGeolocationListItem[]) => {
  return links.map(link => ({
    ...link,
    url: { name: `campervan-hire-slug`, params: { slug: link.slug } },
  }))
}
